import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"

export default class MainArticle extends Component {
  constructor(obj) {
    super(obj)

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })

    gsap.set(this.el, { autoAlpha: 0 })
  }

  animate() {
    const story = qsa(".block-story .char-1", this.el)
    const image = qs(".block-media img", this.el)
    const sideBySideText = qsa(".block-sidebyside .char-1", this.el)
    const sideBySideImage = qs(".block-sidebyside .img", this.el)
    const rightText = qsa(".block-right-text .char-1", this.el)
    const listItems = qsa(".list-item", this.el)
    const sideBySideTwoImages = qsa(".block-img-sidebyside .cover", this.el)

    gsap.to(sideBySideTwoImages, {
      width: "100%",
      height: "100%",
      duration: 1.2,
      scrollTrigger: {
        trigger: sideBySideTwoImages,
        start: "top bottom",
      },
    })

    listItems.forEach(listItem => {
      gsap.from(listItem, {
        y: "50",
        autoAlpha: 0,
        duration: 1.2,
        scrollTrigger: {
          trigger: listItem,
          start: "top bottom",
        },
      })
    })

    gsap.from(story, {
      y: "100%",
      stagger: 0.002,
      duration: 1.2,
      scrollTrigger: {
        trigger: story,
        start: "top bottom",
      },
    })

    gsap.from(rightText, {
      y: "100%",
      stagger: 0.005,
      duration: 1.2,
      scrollTrigger: {
        trigger: rightText,
        start: "top bottom",
      },
    })

    gsap.from(sideBySideText, {
      y: "100%",
      stagger: 0.005,
      duration: 1.2,
      scrollTrigger: {
        trigger: sideBySideText,
        start: "top bottom",
      },
    })
    gsap.to(sideBySideImage, {
      width: "100%",
      height: "100%",
      duration: 1.2,
      scrollTrigger: {
        trigger: sideBySideImage,
        start: "top bottom",
      },
    })

    gsap.to(image, {
      width: "100%",
      height: "100%",
      duration: 1.2,
      scrollTrigger: {
        trigger: image,
        start: "top bottom",
      },
    })

    gsap.set(this.el, { autoAlpha: 1 })
  }
}
